import { render, staticRenderFns } from "./comp_CreditCard-Payment-InstructionsCardContent.vue?vue&type=template&id=67c90194&"
import script from "./comp_CreditCard-Payment-InstructionsCardContent.vue?vue&type=script&lang=js&"
export * from "./comp_CreditCard-Payment-InstructionsCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports